module.exports = __webpack_public_path__ + "assets/img/02.k8s-dashboard-login.5262078f.png";